/*
 * @Author: liujie09
 * @Date: 2021-07-29 14:31:51
 * @Description: some description
 * @LastEditTime: 2021-11-23 14:45:39
 * @FilePath: /kast/packages/bus/src/event.ts
 */
import { isArray, warn, isFunction, isStringSymbolUnion } from './utils';
import { setCache, getCache } from './cache';
import { IEventHooks, StringSymbolUnion, EventCallBack } from './types';

const eventNameSpace = 'event';
class Event implements IEventHooks {
  eventEmitter: object;

  constructor() {
    this.eventEmitter = {};
  }

  emit(key: StringSymbolUnion, ...args: any[]) {
    const keyEmitter = this.eventEmitter[key];

    if (!isArray(keyEmitter) || (isArray(keyEmitter) && keyEmitter.length === 0)) {
      warn(`event.emit: no callback is called for ${String(key)}`);
      return;
    }

    keyEmitter.forEach(cb => {
      cb(...args);
    });
  }

  on(key: StringSymbolUnion, callback: EventCallBack) {
    if (!isStringSymbolUnion(key)) {
      warn('event.on: key should be string / symbol');
      return;
    }
    if (!isFunction(callback)) {
      warn('event.on: callback is required, should be function');
      return;
    }

    if (!this.eventEmitter[key]) {
      this.eventEmitter[key] = [];
    }

    this.eventEmitter[key].push(callback);
  }

  off(key: StringSymbolUnion, callback?: EventCallBack) {
    if (!isStringSymbolUnion(key)) {
      warn('event.off: key should be string / symbol');
      return;
    }

    if (!isArray(this.eventEmitter[key])) {
      warn(`event.off: ${String(key)} has no callback`);
      return;
    }

    if (callback === undefined) {
      this.eventEmitter[key] = undefined;
      return;
    }

    this.eventEmitter[key] = this.eventEmitter[key].filter((cb: EventCallBack) => cb !== callback);
  }

  once(key: StringSymbolUnion, callback?: EventCallBack) {
    const wrapFunc = (...args) => {
      callback.apply(this, args);
      this.off(key, wrapFunc);
    };
    this.on(key, wrapFunc);
  }

  has(key: StringSymbolUnion) {
    const keyEmitter = this.eventEmitter[key];
    return isArray(keyEmitter) && keyEmitter.length > 0;
  }
}

let event = getCache(eventNameSpace);
if (!event) {
  event = new Event();
  setCache(eventNameSpace, event);
}

export default event;
